import { render, staticRenderFns } from "./DialogTbale.vue?vue&type=template&id=3bbb164c&scoped=true"
import script from "./DialogTbale.vue?vue&type=script&lang=js"
export * from "./DialogTbale.vue?vue&type=script&lang=js"
import style0 from "./DialogTbale.vue?vue&type=style&index=0&id=3bbb164c&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbb164c",
  null
  
)

export default component.exports